<template>
  <wui-card
    v-if="hasQueues"
    variant="brand"
    state="text"
    shadow="card"
  >
    <div class="flex phone:flex-wrap items-center gap-4 justify-between">
      <div class="flex items-center gap-4">
        <div class="bg-white rounded-full h-10 w-10 flex items-center justify-center text-black xs:hidden">
          <wui-icon
            name="infoM"
            class="-scale-x-100"
          />
        </div>
        <span class="text-1321">
          {{ $t('common.queueServicesDescription') }}
        </span>
      </div>
      <wui-btn
        variant="brand"
        state="outline"
        @click="goToCallQueues"
      >
        {{ $t('common.configure') }}
      </wui-btn>
    </div>
  </wui-card>
</template>

<script setup lang="ts">
import { WuiBtn, WuiCard, WuiIcon } from '@wui/common-library'
import { storeToRefs } from 'pinia'
import { useRouter } from 'vue-router'

import { useQueueServiceStore } from '@/entities/queue-service'

const { hasQueues } = storeToRefs(useQueueServiceStore())

const router = useRouter()
const goToCallQueues = () => {
  router.push({ name: 'callQueues' })
}
</script>
